import {css} from '@emotion/css';

import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, fonts, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: homepageBusinessServicesCta__container;
  `,
  innerContainer: css`
    label: homepageBusinessServicesCta__innerContainer;
    width: 100%;
    display: flex;
    align-items: center;
  `,
  dialogue: css`
    label: homepageBusinessServicesCta__dialogue;
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    padding-top: ${spacing.XS};
  `,
  innerDialogue: css`
    label: homepageBusinessServicesCta__innerDialogue;
    width: 100%;
    display: flex;
    flex-direction: column;
    ${mq(Breakpoints.TABLET)} {
      flex-direction: row;
    }
  `,
  imageBlock: css`
    label: homepageBusinessServicesCta__imageBlock;
    width: 60%;
    margin: 0 auto;
    padding: ${spacing.S};
    display: flex;
    align-items: center;
    justify-content: center;
    ${mq(Breakpoints.TABLET)} {
      width: 18rem;
      max-width: 100%;
      margin: 0 ${spacing.XL};
    }
  `,
  contentBlock: css`
    label: homepageBusinessServicesCta__contentBlock;
    width: 100%;
    ${mq(Breakpoints.TABLET)} {
      width: calc(100% - 30rem);
    }
  `,
  subheadingWrap: css`
    label: homepageBusinessServicesCta__subheadingWrap;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: ${spacing.XXS} 0;
    padding-top: ${spacing.XS};
  `,
  statusPill: css`
    label: homepageBusinessServicesCta__statusPill;
    background-color: ${colours.brand.SECONDARY_DISABLED};
    color: ${colours.background.SECTION};
    border-radius: 4px;
    padding: 0.2rem 0.6rem 0.1rem 0.6rem;
    font-size: ${fonts.size.XS};
    margin-right: ${spacing.XXXS};
  `,
  subheading: css`
    label: homepageBusinessServicesCta__subheading;
    margin: 0;
    color: ${colours.brand.SECONDARY};
  `,
  copy: css`
    label: homepageBusinessServicesCta__copy;
    color: ${colours.font.ASSISTIVE};
  `,
  layoutMain: css`
    label: homepageBusinessServicesCta__layoutMain;
    padding-top: 0;

    ${mq(Breakpoints.DESKTOP)} {
      padding-top: ${spacing.XXS};
    }
  `,
};

export default styles;
